var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-col", { staticClass: "mt-3 mb-2", attrs: { md: "12" } }, [
    _vm.loading
      ? _c("div", { staticClass: "suggestions-card" }, [
          _c(
            "div",
            { staticClass: "suggestions-header" },
            [
              _c("b-spinner", {
                staticClass: "mr-2",
                attrs: { small: "", variant: "warning" },
              }),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("Carregando sugestões..."))),
              ]),
            ],
            1
          ),
        ])
      : _vm.suggestions.length > 0
      ? _c("div", { staticClass: "suggestions-card" }, [
          _c("div", { staticClass: "suggestions-header" }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("Que tal pedir também?"))),
            ]),
          ]),
          _vm.orientation === "horizontal"
            ? _c("div", { staticClass: "suggestions-list-horizontal" }, [
                _c(
                  "ul",
                  { staticClass: "list-unstyled suggestions-scroll-container" },
                  _vm._l(_vm.suggestions, function (suggestion) {
                    return _c("atm-cart-item", {
                      key: suggestion.skuId,
                      attrs: {
                        "cart-item":
                          _vm.transformSuggestionToCartItem(suggestion),
                        "is-suggestion": true,
                        orientation:
                          _vm.orientation == "horizontal"
                            ? "vertical"
                            : "horizontal",
                        busy: _vm.busy,
                      },
                      on: { "add-suggestion": _vm.onAddSuggestion },
                    })
                  }),
                  1
                ),
              ])
            : _c("div", { staticClass: "suggestions-list" }, [
                _c(
                  "ul",
                  { staticClass: "list-unstyled" },
                  _vm._l(_vm.suggestions, function (suggestion) {
                    return _c("atm-cart-item", {
                      key: suggestion.skuId,
                      attrs: {
                        "cart-item":
                          _vm.transformSuggestionToCartItem(suggestion),
                        "is-suggestion": true,
                        orientation:
                          _vm.orientation == "horizontal"
                            ? "vertical"
                            : "horizontal",
                        busy: _vm.busy,
                      },
                      on: { "add-suggestion": _vm.onAddSuggestion },
                    })
                  }),
                  1
                ),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }